<template>
  <div>
    <div class="top">
      <div class="back">
        <img
          @click="backPage"
          class="add-img"
          src="@/assets/images/back.jpg"
        />字段管理
      </div>
      <div class="search">
         <el-button size="medium" type="primary"  @click="submit"  v-if="codeData.indexOf('210') != -1">保存</el-button>
      </div>
    </div>
    <a-spin :spinning="loading">
      <div class="box">
        <div :style="{height:height}" class="left">
          <div class="title">模型组件</div>
          <div class="box-text">
            <div
              @click="selectItem(item)"
              v-for="(item, index) in models"
              :key="index"
              class="one"
            >
              <div class="one-box">
                <img class="img" :src="item.icon" />
                <div class="text">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>

        <div :style="{height:height}" class="content">
          <div class="title">内容模型字段</div>
          <div v-for="(item, index) in selectModels" :key="index" class="field">
            <div
              @click="selectType(item, index)"
              :style="{ background: selectIndex == index ? '#e7f4ff' : '' }"
              class="card"
              :id="'xx'+index"
              v-if="item.type == 1 || item.type == 12"
            >
              <div class="card-content">
                <div class="card-none">
                  <div class="xin">*</div>
                  <div class="card-text">{{ item.textName }}</div>
                </div>
                <div>
                  <div class="text-plord">{{ item.tips }}</div>
                  <div class="help-text">{{ item.helpInformation }}</div>
                </div>
              </div>

              <div v-if="selectIndex == index" class="delete"></div>
              <i
                @click="deleteFn(item, index)"
                v-if="selectIndex == index"
                class="iconfont icon-guanbi1 icon"
              ></i>
            </div>
            <div
              @click="selectType(item, index)"
              :style="{ background: selectIndex == index ? '#e7f4ff' : '' }"
              v-if="item.type == 2"
              style="padding-bottom: 40px"
              class="card"
              :id="'xx'+index"
            >
              <div class="card-content">
                <div class="card-none">
                  <div class="xin">*</div>
                  <div class="card-text">{{ item.textName }}</div>
                </div>
                <div>
                  <div class="text-plord">{{ item.tips }}</div>
                  <div class="help-text">{{ item.helpInformation }}</div>
                </div>
              </div>
              <div v-if="selectIndex == index" class="delete"></div>
              <i
                @click="deleteFn(item, index)"
                v-if="selectIndex == index"
                class="iconfont icon-guanbi1 icon"
              ></i>
            </div>
            <div
              :style="{ background: selectIndex == index ? '#e7f4ff' : '' }"
              @click="selectType(item, index)"
              v-if="item.type == 3"
              class="card"
              :id="'xx'+index"
            >
              <div class="card-content">
                <div class="card-none">
                  <div class="xin">*</div>
                  <div class="card-text">{{ item.textName }}</div>
                </div>
                <div class="text-plord">
                  <el-radio
                    style="margin-bottom: 10px"
                    :key="reIndex"
                    v-for="(reItem, reIndex) in item.optionContents"
                    v-model="reIndex"
                    :label="0"
                    >{{
                      reItem.content ? reItem.content : "选项" + (reIndex + 1)
                    }}</el-radio
                  >
                  <div style="text-indent: 0" class="help-text">
                    {{ item.helpInformation }}
                  </div>
                </div>
              </div>
              <div v-if="selectIndex == index" class="delete"></div>
              <i
                @click="deleteFn(item, index)"
                v-if="selectIndex == index"
                class="iconfont icon-guanbi1 icon"
              ></i>
            </div>
            <div
              :style="{ background: selectIndex == index ? '#e7f4ff' : '' }"
              @click="selectType(item, index)"
              v-if="item.type == 4"
              class="card"
              :id="'xx'+index"
            >
              <div class="card-content">
                <div class="card-none">
                  <div class="xin">*</div>
                  <div class="card-text">{{ item.textName }}</div>
                </div>
                <div class="text-plord">
                  <el-checkbox
                    style="margin-bottom: 10px"
                    :key="cheIndex"
                    v-for="(cheItem, cheIndex) in item.optionContents"
                    v-model="cheIndex"
                    :label="0"
                    >{{
                      cheItem.content
                        ? cheItem.content
                        : "选项" + (cheIndex + 1)
                    }}</el-checkbox
                  >
                  <div style="text-indent: 0" class="help-text">
                    {{ item.helpInformation }}
                  </div>
                </div>
              </div>
              <div v-if="selectIndex == index" class="delete"></div>
              <i
                @click="deleteFn(item, index)"
                v-if="selectIndex == index"
                class="iconfont icon-guanbi1 icon"
              ></i>
            </div>
            <div
              :style="{ background: selectIndex == index ? '#e7f4ff' : '' }"
              @click="selectType(item, index)"
              v-if="item.type == 5"
              class="card"
              :id="'xx'+index"
            >
              <div class="card-content">
                <div class="card-none">
                  <div class="xin">*</div>
                  <div class="card-text">{{ item.textName }}</div>
                </div>
                <div class="text-plord">请选择</div>
                <i
                  style="position: absolute; right: 18px"
                  class="el-icon-arrow-down"
                ></i>
              </div>
              <div class="help-select">{{ item.helpInformation }}</div>

              <div v-if="selectIndex == index" class="delete"></div>
              <i
                @click="deleteFn(item, index)"
                v-if="selectIndex == index"
                class="iconfont icon-guanbi1 icon"
              ></i>
            </div>
            <div
              :style="{ background: selectIndex == index ? '#e7f4ff' : '' }"
              @click="selectType(item, index)"
              v-if="item.type == 6"
              class="card"
              :id="'xx'+index"
            >
              <div class="card-content">
                <div class="card-none">
                  <div class="xin">*</div>
                  <div class="card-text">{{ item.textName }}</div>
                </div>
                <div class="text-plord">
                  {{
                    item.dateType == 0
                      ? "年 /月/日"
                      : item.dateType == 1
                      ? "--:--"
                      : "年 /月/日 --:--"
                  }}
                </div>
                <i
                  style="position: absolute; right: 18px"
                  class="el-icon-date"
                ></i>
              </div>
              <div class="help-select">{{ item.helpInformation }}</div>
              <div v-if="selectIndex == index" class="delete"></div>
              <i
                @click="deleteFn(item, index)"
                v-if="selectIndex == index"
                class="iconfont icon-guanbi1 icon"
              ></i>
            </div>
            <div
              :style="{ background: selectIndex == index ? '#e7f4ff' : '' }"
              @click="selectType(item, index)"
              v-if="item.type == 7"
              class="card"
              :id="'xx'+index"
            >
              <div class="card-content">
                <div class="card-none">
                  <div style="margin-top: 10px" class="xin">*</div>
                  <div style="margin-top: 10px" class="card-text">
                    {{ item.textName }}
                  </div>
                </div>
                <div class="text-plord">
                  <img class="img" src="@/assets/images/d_img_upload.jpg" />
                </div>
              </div>
              <div class="help-select">{{ item.helpInformation }}</div>
              <div v-if="selectIndex == index" class="delete"></div>
              <i
                @click="deleteFn(item, index)"
                v-if="selectIndex == index"
                class="iconfont icon-guanbi1 icon"
              ></i>
            </div>
            <div
              :style="{ background: selectIndex == index ? '#e7f4ff' : '' }"
              @click="selectType(item, index)"
              v-if="item.type == 8"
              class="card"
               :id="'xx'+index"
            >
              <div class="card-content">
                <div class="card-none">
                  <div style="margin-top: 8px" class="xin">*</div>
                  <div style="margin-top: 8px" class="card-text">
                    {{ item.textName }}
                  </div>
                </div>
                <div class="text-plord">
                  <el-button type="primary">选择图片</el-button>
                </div>
              </div>
              <div v-if="selectIndex == index" class="delete"></div>
              <i
                @click="deleteFn(item, index)"
                v-if="selectIndex == index"
                class="iconfont icon-guanbi1 icon"
              ></i>
            </div>
            <div
              :style="{ background: selectIndex == index ? '#e7f4ff' : '' }"
              @click="selectType(item, index)"
              v-if="item.type == 9"
              class="card"
               :id="'xx'+index"
            >
              <div class="card-content">
                <div class="card-none">
                  <div style="margin-top: 10px" class="xin">*</div>
                  <div style="margin-top: 10px" class="card-text">
                    {{ item.textName }}
                  </div>
                </div>
                <div class="text-plord">
                  <img class="img" src="@/assets/images/mp4_upload.jpg" />
                </div>
              </div>
              <div v-if="selectIndex == index" class="delete"></div>
              <i
                @click="deleteFn(item, index)"
                v-if="selectIndex == index"
                class="iconfont icon-guanbi1 icon"
              ></i>
            </div>
            <div
              :style="{ background: selectIndex == index ? '#e7f4ff' : '' }"
              @click="selectType(item, index)"
              v-if="item.type == 10"
              class="card"
               :id="'xx'+index"
            >
              <div class="card-content">
                <div class="card-none">
                  <div style="margin-top: 10px" class="xin">*</div>
                  <div style="margin-top: 10px" class="card-text">
                    {{ item.textName }}
                  </div>
                </div>
                <div class="text-plord">
                  <img class="img" src="@/assets/images/video_upload.jpg" />
                </div>
              </div>
              <div v-if="selectIndex == index" class="delete"></div>
              <i
                @click="deleteFn(item, index)"
                v-if="selectIndex == index"
                class="iconfont icon-guanbi1 icon"
              ></i>
            </div>
            <div
              :style="{ background: selectIndex == index ? '#e7f4ff' : '' }"
              @click="selectType(item, index)"
              v-if="item.type == 11"
              class="card"
               :id="'xx'+index"
            >
              <div class="card-content">
                <div class="card-none">
                  <div style="margin-top: 8px" class="xin">*</div>
                  <div style="margin-top: 8px" class="card-text">
                    {{ item.textName }}
                  </div>
                </div>
                <div class="text-plord">
                  <el-button type="primary">选择附件</el-button>
                </div>
              </div>
              <div v-if="selectIndex == index" class="delete"></div>
              <i
                @click="deleteFn(item, index)"
                v-if="selectIndex == index"
                class="iconfont icon-guanbi1 icon"
              ></i>
            </div>
          </div>
        </div>
        <div  :style="{height:height}" class="right">
          <div class="title">组件属性设置</div>
          <div  v-if="selectModels.length > 0" class="form">
            <el-form
              :model="selectModels[selectIndex]"
              :rules="rules"
              ref="ruleForm"
              label-width="80px"
             
              class="demo-ruleForm"
            >
              <div
                v-if="
                  selectTypeOne == 1 ||
                  selectTypeOne == 2 ||
                  selectTypeOne == 12
                "
              >
                <el-form-item label="字段名称" prop="textName">
                  <el-input
                    v-model="selectModels[selectIndex].textName"
                    placeholder="输入字段名称"
                    :maxlength="5"
                  ></el-input>
                </el-form-item>
                <el-form-item label="标签名称" prop="labelName">
                  <el-input
                    v-model="selectModels[selectIndex].labelName"
                    placeholder="输入标签名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="提示文字">
                  <el-input
                    v-model="selectModels[selectIndex].tips"
                    placeholder="请输入提示文字"
                  ></el-input>
                </el-form-item>
                <el-form-item label="帮助信息">
                  <el-input
                    v-model="selectModels[selectIndex].helpInformation"
                    placeholder="请输入帮助信息"
                  ></el-input>
                </el-form-item>
                <el-form-item label="字数限制" prop="wordLimit">
                  <el-input-number
                    :min='0'
                    v-model="selectModels[selectIndex].wordLimit"
                  ></el-input-number>
                  <div style="color: #ccc; font-size: 14px">
                    请输入整数,0为不限制
                  </div>
                </el-form-item>
                <el-form-item label="输入限制" prop="inputLimits">
                  <el-select
                    v-model="selectModels[selectIndex].inputLimits"
                    clearable
                    placeholder="请选择"
                  >
                    <el-option label="不限制" :value="0"></el-option>
                    <el-option label="只能输入中文" :value="1"></el-option>
                    <el-option label="只能输入英文" :value="2"></el-option>
                    <el-option label="只能输入数字" :value="3"></el-option>
                    <el-option label="只能输入手机号" :value="4"></el-option>
                    <el-option label="只能输入邮箱" :value="5"></el-option>
                    <el-option label="只能输入身份证号" :value="6"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否必填" prop="flagRequired">
                  <div class="status">
                    <el-radio
                      v-model="selectModels[selectIndex].flagRequired"
                      :label="0"
                      >是</el-radio
                    >
                    <el-radio
                      v-model="selectModels[selectIndex].flagRequired"
                      :label="1"
                      >否</el-radio
                    >
                  </div>
                </el-form-item>
              </div>
              <div
                v-if="
                  selectTypeOne == 3 || selectTypeOne == 4 || selectTypeOne == 5
                "
              >
                <el-form-item label="字段名称" prop="textName">
                  <el-input
                    v-model="selectModels[selectIndex].textName"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="标签名称" prop="labelName">
                  <el-input
                    v-model="selectModels[selectIndex].labelName"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="帮助信息">
                  <el-input
                    v-model="selectModels[selectIndex].helpInformation"
                    placeholder="请输入帮助信息"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  v-if="selectTypeOne == 3"
                  label="选项内容"
                  prop="optionContents"
                >
                  <vuedraggable
                    @end="onUpdate"
                    class="wrapper"
                    v-model="selectModels[selectIndex].optionContents"
                  >
                    <!-- 过度效果 -->
                    <transition-group>
                      <div
                        class="radio"
                        :key="redioIndex"
                        v-for="(redio, redioIndex) in selectModels[selectIndex]
                          .optionContents"
                      >
                        <el-radio v-model="redioIndex" :label="0"></el-radio>
                        <el-input
                          v-model="
                            selectModels[selectIndex].optionContents[redioIndex]
                              .content
                          "
                          style="width: 137px"
                          placeholder="请输入内容"
                        ></el-input>
                        <img
                          @click="tianjia(redioIndex)"
                          class="rideo-img"
                          src="@/assets/images/tianjia.jpg"
                        />
                        <img
                          @click="jianqu(redioIndex)"
                          class="rideo-img"
                          src="@/assets/images/jianqu.jpg"
                        />
                        <img class="rideo-img" src="@/assets/images/sort.jpg" />
                      </div>
                    </transition-group>
                  </vuedraggable>
                </el-form-item>
                <el-form-item
                  v-if="selectTypeOne == 4"
                  label="选项内容"
                  prop="optionContents"
                >
                  <vuedraggable
                    @end="onUpdate"
                    class="wrapper"
                    v-model="selectModels[selectIndex].optionContents"
                  >
                    <!-- 过度效果 -->
                    <transition-group>
                      <div
                        class="radio"
                        :key="redioIndex"
                        v-for="(redio, redioIndex) in selectModels[selectIndex]
                          .optionContents"
                      >
                        <el-checkbox style="margin-right: 10px"> </el-checkbox>
                        <el-input
                          v-model="
                            selectModels[selectIndex].optionContents[redioIndex]
                              .content
                          "
                          style="width: 137px"
                          placeholder="请输入内容"
                        ></el-input>
                        <img
                          @click="tianjia(redioIndex)"
                          class="rideo-img"
                          src="@/assets/images/tianjia.jpg"
                        />
                        <img
                          @click="jianqu(redioIndex)"
                          class="rideo-img"
                          src="@/assets/images/jianqu.jpg"
                        />
                        <img class="rideo-img" src="@/assets/images/sort.jpg" />
                      </div>
                    </transition-group>
                  </vuedraggable>
                </el-form-item>
                <el-form-item
                  v-if="selectTypeOne == 5"
                  label="选项内容"
                  prop="optionContents"
                >
                  <vuedraggable
                    @end="onUpdate"
                    class="wrapper"
                    v-model="selectModels[selectIndex].optionContents"
                  >
                    <!-- 过度效果 -->
                    <transition-group>
                      <div
                        class="radio"
                        :key="redioIndex"
                        v-for="(redio, redioIndex) in selectModels[selectIndex]
                          .optionContents"
                      >
                        <el-radio> </el-radio>
                        <el-input
                          v-model="
                            selectModels[selectIndex].optionContents[redioIndex]
                              .content
                          "
                          style="width: 137px"
                          placeholder="请输入内容"
                        ></el-input>
                        <img
                          @click="tianjia(redioIndex)"
                          class="rideo-img"
                          src="@/assets/images/tianjia.jpg"
                        />
                        <img
                          @click="jianqu(redioIndex)"
                          class="rideo-img"
                          src="@/assets/images/jianqu.jpg"
                        />
                        <img class="rideo-img" src="@/assets/images/sort.jpg" />
                      </div>
                    </transition-group>
                  </vuedraggable>
                </el-form-item>
                <el-form-item label="是否必填" prop="flagRequired">
                  <div class="status">
                    <el-radio
                      v-model="selectModels[selectIndex].flagRequired"
                      :label="0"
                      >是</el-radio
                    >
                    <el-radio
                      v-model="selectModels[selectIndex].flagRequired"
                      :label="1"
                      >否</el-radio
                    >
                  </div>
                </el-form-item>
              </div>
              <div v-if="selectTypeOne == 6">
                <el-form-item label="字段名称" prop="textName">
                  <el-input
                    v-model="selectModels[selectIndex].textName"
                    placeholder="单行文本"
                  ></el-input>
                </el-form-item>
                <el-form-item label="标签名称" prop="labelName">
                  <el-input
                    v-model="selectModels[selectIndex].labelName"
                    placeholder="单行文本"
                  ></el-input>
                </el-form-item>
                <el-form-item label="帮助信息">
                  <el-input
                    v-model="selectModels[selectIndex].helpInformation"
                    placeholder="请输入帮助信息"
                  ></el-input>
                </el-form-item>
                <el-form-item label="时间类型" prop="dateType">
                  <el-select
                    v-model="selectModels[selectIndex].dateType"
                    placeholder="请选择"
                  >
                    <el-option label="日期" :value="0"></el-option>
                    <el-option label="时间" :value="1"></el-option>
                    <el-option label="日期+时间" :value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="默认时间" prop="defaultDate">
                  <div class="status">
                    <el-radio
                      v-model="selectModels[selectIndex].defaultDate"
                      :label="0"
                      >显示当前时间</el-radio
                    >
                    <el-radio
                      v-model="selectModels[selectIndex].defaultDate"
                      :label="1"
                      >不显示</el-radio
                    >
                  </div>
                </el-form-item>
                <el-form-item label="是否必填" prop="flagRequired">
                  <div class="status">
                    <el-radio
                      v-model="selectModels[selectIndex].flagRequired"
                      :label="0"
                      >是</el-radio
                    >
                    <el-radio
                      v-model="selectModels[selectIndex].flagRequired"
                      :label="1"
                      >否</el-radio
                    >
                  </div>
                </el-form-item>
              </div>
              <div
                v-if="
                  selectTypeOne == 7 ||
                  selectTypeOne == 8 ||
                  selectTypeOne == 9 ||
                  selectTypeOne == 10 ||
                  selectTypeOne == 11
                "
              >
                <el-form-item label="字段名称" prop="textName">
                  <el-input
                    v-model="selectModels[selectIndex].textName"
                    placeholder="字段名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="标签名称" prop="labelName">
                  <el-input
                    v-model="selectModels[selectIndex].labelName"
                    placeholder="标签名称"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  v-if="selectTypeOne == 7 || selectTypeOne == 8"
                  label="图片类型"
                  prop="uploadType"
                >
                  <el-select
                    style="width: 100%"
                    multiple
                    v-model="selectModels[selectIndex].uploadType"
                    placeholder="请选择"
                  >
                    <el-option label="jpg" value="jpg"></el-option>
                    <el-option label="jpeg" value="jpeg"></el-option>
                    <el-option label="png" value="png"></el-option>
                    <el-option label="gif" value="gif"></el-option>
                    <el-option label="bmp" value="bmp"></el-option>
                    <el-option label="webp" value="webp"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="帮助信息">
                  <el-input
                    v-model="selectModels[selectIndex].helpInformation"
                    placeholder="请输入帮助信息"
                  ></el-input>
                </el-form-item>

                <el-form-item
                  v-if="selectTypeOne == 9"
                  label="视频类型"
                  prop="uploadType"
                >
                  <el-select
                    style="width: 100%"
                    multiple
                    v-model="selectModels[selectIndex].uploadType"
                    placeholder="请选择"
                  >
                    <el-option label="mp4" value="mp4"></el-option>
                    <el-option label="mov" value="mov"></el-option>
                    <el-option label="rmvb" value="rmvb"></el-option>
                    <el-option label="3gp" value="3gp"></el-option>
                    <el-option label="wmv" value="wmv"></el-option>
                    <el-option label="m4v" value="m4v"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  v-if="selectTypeOne == 10"
                  label="音频类型"
                  prop="uploadType"
                >
                  <el-select
                    style="width: 100%"
                    multiple
                    v-model="selectModels[selectIndex].uploadType"
                    placeholder="请选择"
                  >
                    <el-option label="mp3" value="mp3"></el-option>
                    <el-option label="wav" value="wav"></el-option>
                    <el-option label="ogg" value="ogg"></el-option>
                    <el-option label="acc" value="acc"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  v-if="selectTypeOne == 11"
                  label="附件类型"
                  prop="uploadType"
                >
                  <el-select
                    style="width: 100%"
                    multiple
                    v-model="selectModels[selectIndex].uploadType"
                    placeholder="请选择"
                  >
                    <el-option label="doc" value="doc"></el-option>
                    <el-option label="docx" value="docx"></el-option>
                    <el-option label="pdf" value="pdf"></el-option>
                    <el-option label="ppt" value="ppt"></el-option>
                    <el-option label="pptx" value="pptx"></el-option>
                    <el-option label="zip" value="zip"></el-option>
                    <el-option label="xls" value="xls"></el-option>
                    <el-option label="xlsx" value="xlsx"></el-option>
                    <el-option label="rar" value="rar"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="大小限制" prop="fileSize">
                  <a-input
                   type="number"
                    onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''"
                    addon-before="不超过"
                    v-model="selectModels[selectIndex].fileSize"
                    oninput="if(value<0)value=0"
                  >
                    <a-select
                      v-model="selectModels[selectIndex].dataType"
                      slot="addonAfter"
                      default-value="KB"
                    >
                      <a-select-option :value="0"> KB </a-select-option>
                      <a-select-option :value="1"> MB </a-select-option>
                    </a-select>
                  </a-input>
                  <div v-if="selectTypeOne < 9" style="color: #ccc; font-size: 14px">
                    请输入整数,0为不限制
                  </div>
                  <div v-if="selectTypeOne >= 9" style="color: #ccc; font-size: 14px">
                    单个最大50MB
                  </div>
                </el-form-item>
                <el-form-item
                  v-if="selectTypeOne == 8"
                  label="数量限制"
                  prop="number"
                >
                  <el-input-number
                    style="width: 100%"
                    v-model="selectModels[selectIndex].number"
                    :min="2"
                    :max="9"
                  ></el-input-number>
                   <div style="color: #ccc; font-size: 14px">
                    至少2张,最多9张
                  </div>
                </el-form-item>
                <el-form-item label="是否必填" prop="flagRequired">
                  <div class="status">
                    <el-radio
                      v-model="selectModels[selectIndex].flagRequired"
                      :label="0"
                      >是</el-radio
                    >
                    <el-radio
                      v-model="selectModels[selectIndex].flagRequired"
                      :label="1"
                      >否</el-radio
                    >
                  </div>
                </el-form-item>
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import { message } from "ant-design-vue";
// 导入组件
import vuedraggable from "vuedraggable";
import {
  createAndUpdate,
  selectListByModelId,
} from "./substance_model_management";

export default {
  name: "HelloWorld",
  components: { vuedraggable },
  props: {},
  data() {
    return {
      // 定义列表
      models: [
        {
          type: 1,
          name: "单行文本",
          id: 1,
          icon: require("@/assets/images/d_text.jpg"),
        },
        {
          type: 2,
          name: "多行文本",
          id: 2,
          icon: require("@/assets/images/texts.png"),
        },
        {
          type: 3,
          name: "单选按钮",
          id: 3,
          icon: require("@/assets/images/d_btn.png"),
        },
        {
          type: 4,
          name: "多选按钮",
          id: 4,
          icon: require("@/assets/images/d_btns.png"),
        },
        {
          type: 5,
          name: "下拉选框",
          id: 5,
          icon: require("@/assets/images/select.png"),
        },
        {
          type: 6,
          name: "日期时间",
          id: 6,
          icon: require("@/assets/images/time.png"),
        },
        {
          type: 7,
          name: "单图上传",
          id: 7,
          icon: require("@/assets/images/d_img.png"),
        },
        {
          type: 8,
          name: "多图上传",
          id: 8,
          icon: require("@/assets/images/d_imgs.png"),
        },
        {
          type: 9,
          name: "视频上传",
          id: 9,
          icon: require("@/assets/images/vedio.png"),
        },
        {
          type: 10,
          name: "音频上传",
          id: 10,
          icon: require("@/assets/images/mp4.jpg"),
        },
        {
          type: 11,
          name: "附件上传",
          id: 11,
          icon: require("@/assets/images/file.jpg"),
        },
        {
          type: 12,
          name: "索引号",
          id: 12,
          icon: require("@/assets/images/d_text.jpg"),
        },
      ],
      radio: "1",
      checked: "",
      selectModels: [],
      selectIndex: 0,
      rules: {
        textName: [
          { required: true, message: "请输入字段名称", trigger: "blur" },
        ],
        labelName: [
          { required: true, message: "请输入标签名称", trigger: "blur" },
        ],
        wordLimit: [
          { required: true, message: "请输入字数限制", trigger: "blur" },
        ],
        optionContents: [
          { required: true, message: "请输入选项内容", trigger: "blur" },
        ],
        inputLimits: [
          { required: true, message: "请输入限制", trigger: "blur" },
        ],
        flagRequired: [
          { required: true, message: "请输入是否必填", trigger: "change" },
        ],
        dateType: [
          { required: true, message: "请输入时间类型", trigger: "blur" },
        ],
        defaultDate: [
          { required: true, message: "请输入默认时间", trigger: "blur" },
        ],
        uploadType: [
          { required: true, message: "请输入上传类型", trigger: "blur" },
        ],
        fileSize: [
          { required: true, message: "请输入大小限制", trigger: "blur" },
        ],
      },
      selectTypeOne: 1,
      loading: false,
      codeData: [],
      height:0,
    };
  },
  updated() {},
  mounted(){
    this.height = (document.documentElement.clientHeight - 220) + 'px';
        window.onresize = () => {
            return (() => {
                this.height = (document.documentElement.clientHeight - 220) + 'px';
            })();
        };
  },
  created() {
    this.getSelectList();
    this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
  },
  methods: {
    goAnchor(selector) {
      this.$el.querySelector(`#${selector}`).scrollIntoView({
          behavior: "smooth",  // 平滑过渡
          block:    "start"  // 上边框与视窗顶部平齐。默认值
      });
    },
    getSelectList() {
      this.loading = true;
      selectListByModelId({
        id: this.$route.query.id,
      }).then((res) => {
        if (res.code == 0) {
          // 处理单行或者多行文本 数据回显
          if (res.data.fieldTextCreateRequests) {
            res.data.fieldTextCreateRequests.forEach((elementText) => {
              elementText.type = elementText.type == 0 ? 1 : 2;
              this.selectModels.push(elementText);
            });
          }
          // 处理单选 或者 多选 或者 下拉
          if (res.data.fieldOptionCreateRequests) {
            res.data.fieldOptionCreateRequests.forEach((itemSelect) => {
              itemSelect.type =
                itemSelect.type == 0 ? 3 : itemSelect.type == 1 ? 4 : 5;
              this.selectModels.push(itemSelect);
            });
          }
          // 处理日期时间
          if (res.data.dateCreateRequest) {
            res.data.dateCreateRequest.forEach((itemTime) => {
              itemTime.type = 6;
              this.selectModels.push(itemTime);
            });
          }
          // 处理 文件上传
          if (res.data.fieldFileCreateRequests) {
            res.data.fieldFileCreateRequests.forEach((itemFiles) => {
              itemFiles.type =
                itemFiles.type == 0
                  ? 7
                  : itemFiles.type == 1
                  ? 8
                  : itemFiles.type == 2
                  ? 9
                  : itemFiles.type == 3
                  ? 10
                  : 11;
              itemFiles.uploadType = itemFiles.uploadType.split(",");
              this.selectModels.push(itemFiles);
            });
          }
          if (res.data.indexRequests) {
            res.data.indexRequests.forEach((element) => {
              element.type = 12;
              this.selectModels.push(element);
            });
          }
          if (this.selectModels.length == 0) {
            this.selectModels.push({
              type: 1,
              textName: "单行文本",
              labelName: "",
              tips: "请输入内容",
              helpInformation: "",
              wordLimit: "50",
              inputLimits: 0,
              flagRequired: 0,
            });
          }
          this.selectType({},0)
          this.loading = false;
        }
      });
    },
    backPage() {
      this.$router.push("/index/configure/substance_model_management");
    },
    submit() {
      let validData = JSON.parse(JSON.stringify(this.selectModels));
      let array = [];
      for (let index = 0; index < validData.length; index++) {
        let item = validData[index];
        if(item.flagRequired !== 0 && item.flagRequired !== 1){ // 验证是否必填
                  message.error('请正确填写数据')
                  this.selectType(item,index);
                  this.goAnchor('xx'+index);
                  this.$nextTick(()=>{
                     this.$refs.ruleForm.validate((valid) => {
                       
                    })
                  })
                  return;
              }
              if(!item.textName){ // 验证字段是否填写
                  message.error('请正确填写数据')
                  this.selectType(item,index);
                   this.goAnchor('xx'+index);
                  this.$nextTick(()=>{
                     this.$refs.ruleForm.validate((valid) => {
                       
                    })
                  })
                  return;
              }
               if(!item.labelName){ // 验证标签名是否填写
                  message.error('请正确填写数据')
                  this.selectType(item,index);
                   this.goAnchor('xx'+index);
                  this.$nextTick(()=>{
                     this.$refs.ruleForm.validate((valid) => {
                       
                    })
                  })
                  return;
              }
          if(item.type == 1 || item.type == 2 || item.type == 12){ // 验证单行文本
              if(!item.wordLimit && item.wordLimit != 0){ // 验证字数限制
                  message.error('请正确填写数据')
                  this.selectType(item,index);
                   this.goAnchor('xx'+index);
                  this.$nextTick(()=>{
                     this.$refs.ruleForm.validate((valid) => {
                       
                    })
                  })
                  return;
              }
              if(!item.inputLimits && item.inputLimits != 0){ // 验证输入限制
                  message.error('请正确填写数据')
                  this.selectType(item,index);
                   this.goAnchor('xx'+index);
                  this.$nextTick(()=>{
                     this.$refs.ruleForm.validate((valid) => {
                       
                    })
                  })
                  return;
              }   
          }

          // 验证多选按钮
          if(item.type == 4 || item.type == 3 || item.type == 5){
              for (let indexTwo = 0; indexTwo < item.optionContents.length; indexTwo++) {
                 if(!item.optionContents[indexTwo].content){
                      this.selectType(item,index);
                       this.goAnchor('xx'+index);
                      message.error('选项内容必填')
                  return;
                 }
                 
              }
          }
          if(item.type == 8){
              if(item.number<2 || item.number > 9){
                   this.selectType(item,index);
                       this.goAnchor('xx'+index);
                      message.error('至少2两张,最多9张')
                       return;
              } 
          }
          if(item.type == 9 || item.type == 10 || item.type == 11){
               if(item.dataType==1 && item.fileSize > 50){
                  this.selectType(item,index);
                  this.goAnchor('xx'+index);
                  message.error('单个最大50MB')
                  return;
               }
               if(item.dataType==0 && item.fileSize > 50*1024*1024){
                  this.selectType(item,index);
                  this.goAnchor('xx'+index);
                  message.error('单个最大50MB')
                  return;
               }
          }
          // 图片上传限制
          if(item.type == 7 || item.type == 8 || item.type == 9 || item.type == 10 || item.type == 11){
              if(item.uploadType && item.uploadType.length == 0){
                      this.selectType(item,index);
                       this.goAnchor('xx'+index);
                      message.error('请选择类型')
                  return;
                 }
              //  if(!item.fileSize){
              //         this.selectType(item,index);
              //          this.goAnchor('xx'+index);
              //         message.error('请输入大小限制')
              //     return;
              //    }
          }
      }
          let fieldTextCreateRequests = []; // 单行多行文本
          let dateCreateRequest = []; // 日期时间
          let fieldOptionCreateRequests = []; // 单选多选
          let fieldFileCreateRequests = []; // 音频，视频，文件上传
          let indexRequests = [];
          let arrayData = JSON.parse(JSON.stringify(this.selectModels));
          arrayData.forEach((element) => {
            if (element.type == 1 || element.type == 2) {
              element.type = element.type == 1 ? 0 : 1;
              fieldTextCreateRequests.push(element);
            }
            if (element.type == 3 || element.type == 4 || element.type == 5) {
              element.type = element.type == 3 ? 0 : element.type == 4 ? 1 : 2;
              fieldOptionCreateRequests.push(element);
            }
            if (element.type == 6) {
              dateCreateRequest.push(element);
            }
            if (
              element.type == 7 ||
              element.type == 8 ||
              element.type == 9 ||
              element.type == 10 ||
              element.type == 11
            ) {
              console.log(element.uploadType, element.type, "-----------");
              switch (element.type) {
                case 7:
                  element.type = 0;
                  element.uploadType = element.uploadType.join(",");
                  fieldFileCreateRequests.push(element);
                  break;
                case 8:
                  element.type = 1;
                  element.uploadType = element.uploadType.join(",");
                  fieldFileCreateRequests.push(element);
                  break;
                case 9:
                  element.type = 2;
                  element.uploadType = element.uploadType.join(",");
                  fieldFileCreateRequests.push(element);
                  break;
                case 10:
                  element.type = 3;
                  element.uploadType = element.uploadType.join(",");
                  fieldFileCreateRequests.push(element);
                  break;
                case 11:
                  element.type = 4;
                  element.uploadType = element.uploadType.join(",");
                  fieldFileCreateRequests.push(element);
                  break;
                default:
                  return;
              }
            }
            if (element.type == 12) {
              element.type = 11;
              indexRequests.push(element);
            }
          });
          createAndUpdate({
            modelId: this.$route.query.id,
            fieldTextCreateRequests,
            dateCreateRequest,
            fieldOptionCreateRequests,
            fieldFileCreateRequests,
            indexRequests,
          }).then((res) => {
            if (res.code == 0) {
              message.success("保存数据成功");
            }
          });
    },
    onUpdate() {
      // 处理排序
      if (
        this.selectModels[this.selectIndex] &&
        this.selectModels[this.selectIndex].optionContents
      ) {
        this.selectModels[this.selectIndex].optionContents.forEach(
          (element, index) => {
            element.sort = index;
          }
        );
      }
    },
    tianjia() {
      this.selectModels[this.selectIndex].optionContents.push({
        content: "",
        sort: this.selectModels[this.selectIndex].optionContents.length,
      });
    },
    jianqu(index) {
      if (this.selectModels[this.selectIndex].optionContents.length == 1) {
        message.error("需要保留一个选项");
        return;
      }
      this.selectModels[this.selectIndex].optionContents.splice(index, 1);
      this.onUpdate();
    },
    selectType(item, index) {
      if (index == this.selectModels.length) {
        this.selectIndex = 0;
        this.selectTypeOne = this.selectModels[this.selectIndex].type;
      } else {
        this.selectIndex = index;
        this.selectTypeOne = this.selectModels[this.selectIndex].type;
      }
      this.selectModels = JSON.parse(JSON.stringify(this.selectModels));
    },
    selectItem(item) {
      let itemData = {};
      if (item.type == 1 || item.type == 2 || item.type == 12) {
        itemData = {
          type: item.type,
          textName:
            item.type == 1
              ? "单行文本"
              : item.type == 2
              ? "多行文本"
              : "索引号",
          labelName: "",
          tips: "请输入内容",
          helpInformation: "",
          wordLimit: "50",
          inputLimits: 0,
          flagRequired: 0,
        };
      }
      if (item.type == 3 || item.type == 4 || item.type == 5) {
        itemData = {
          type: item.type,
          textName:
            item.type == 3
              ? "单选按钮"
              : item.type == 4
              ? "多选按钮"
              : "下拉框",
          labelName: "",
          helpInformation: "",
          optionContents: [
            {
              content: "",
              sort: 1,
            },
            {
              content: "",
              sort: 2,
            },
          ],
          flagRequired: 0,
        };
      }
      if (item.type == 6) {
        itemData = {
          type: item.type,
          textName: "日期时间",
          labelName: "",
          helpInformation: "",
          dateType: 0,
          flagRequired: 0,
          defaultDate: 0,
        };
      }
      if (
        item.type == 7 ||
        item.type == 8 ||
        item.type == 9 ||
        item.type == 10 ||
        item.type == 11
      ) {
        itemData = {
          type: item.type,
          textName:
            item.type == 7
              ? "单图上传"
              : item.type == 8
              ? "多图上传"
              : item.type == 9
              ? "视频上传"
              : item.type == 10
              ? "音频上传"
              : "附件上传",
          labelName: "",
          helpInformation: "",
          uploadType:
            item.type == 7
              ? ["jpg", "jpeg", "png"]
              : item.type == 8
              ? ["jpg", "jpeg", "png"]
              : item.type == 9
              ? ["mp4", "mov", "rmvb"]
              : item.type == 10
              ? ["mp3", "wav", "ogg"]
              : ["doc", "docx", "pdf"],
          fileSize: "10",
          dataType: 0,
          number: item.type == 8?"2":'1',
          flagRequired: 0,
        };
      }

      this.selectModels.push(itemData);
    },
    deleteFn(item, index) {
      if (this.selectModels.length == 1) {
        message.error("必须保留一个选项");
        return;
      }
      this.selectModels.splice(index, 1);
      this.selectType(item, index);
    },
    handleChange() {},
  },
};
</script>
<style lang="less" scoped>
.top {
  width: 100%;
  padding: 24px;
  border-bottom: solid #f4f4f6 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .search {
    display: flex;
  }
  .back {
    font-size: 18px;
    font-weight: 600;
    color: #000;
  }
  .add-img {
    margin-right: 5px;
    margin-top: -3px;
    cursor: pointer;
  }
}
.box {
  display: flex;
  .left {
    width: 260px;
    background: #fff;
    padding: 24px;
    scrollbar-width: none; /* firefox */
    -ms-overflow-style: none; /* IE 10+ */
    overflow-x: hidden;
    overflow-y: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
    ::-webkit-scrollbar {
      display: none; /* Chrome Safari */
    }
    .title {
      font-weight: 600;
      font-size: 16px;
      color: #000;
    }
    .box-text {
      display: flex;
      flex-wrap: wrap;
      margin-top: 24px;
    }
    .one {
      width: 90px;
      height: 90px;
      text-align: center;
      border: solid 1px #d9d9d9;
      display: flex;
      align-items: center;
      border-bottom: none;
      box-shadow: 0px 0px 1.5px 0px #d9d9d9;
      cursor: pointer;
      .one-box {
        text-align: center;
        width: 100%;
        .text {
          margin-top: 6px;
        }
      }
    }
    .one:nth-child(2) {
      .text {
        margin-top: 7px;
      }
    }
    .one:nth-child(2n) {
      border-left: none;
    }
    .one:nth-child(11) {
      border-bottom: solid 1px #d9d9d9;
    }
    .one:nth-child(12) {
      border-bottom: solid 1px #d9d9d9;
    }
  }
  .content {
    flex: 1;
    background: #f2f3f5;
    padding: 24px;
    overflow-y: auto;
    .title {
      font-weight: 600;
      font-size: 16px;
      color: #000;
    }
    .card {
      background: #fff;
      border-radius: 6px;
      position: relative;
      width: 100%;
      font-size: 16px;
      color: #000;
      margin-top: 24px;
      cursor: pointer;
      .card-content {
        display: flex;
        padding: 24px;
      }
      .card-none {
        display: flex;
        .xin {
          color: #de7baa;
          margin-right: 4px;
        }
      }
      .text-plord {
        margin-left: 20px;
      }
    }
    .delete {
      width: 100%;
      height: 100%;
      position: absolute;
      border: dashed 2px #1890ff;
      border-radius: 4px;
      top: 0;
      right: 0;
    }
    .icon {
      color: #1890ff;
      font-size: 24px;
      position: absolute;
      right: -10px;
      top: -16px;
      z-index: 99999;
    }
    /deep/ .el-radio__inner::after {
      width: 8px;
      height: 8px;
    }
    /deep/ .el-radio__inner {
      width: 18px;
      height: 18px;
    }
    /deep/ .el-checkbox__inner {
      width: 18px;
      height: 18px;
    }
  }
  .right {
    width: 400px;
    padding: 24px;
    overflow-y: auto;
    .title {
      font-weight: 600;
      font-size: 16px;
      color: #000;
    }
    .form {
      margin-top: 24px;
      .status {
        border: solid 1px #dcdfe6;
        border-radius: 4px;
        padding-left: 10px;
      }
      /deep/ .el-radio__inner::after {
        width: 8px;
        height: 8px;
      }
      /deep/ .el-radio__inner {
        width: 16px;
        height: 16px;
      }
    }
  }
}
.radio {
  margin-bottom: 12px;
  /deep/ .el-radio {
    margin-right: 0px !important;
  }
  /deep/ .el-radio__label {
    display: none !important;
  }
  /deep/ .el-radio__input {
    margin-right: 10px;
  }
}
.rideo-img {
  width: 18px;
  height: 18px;
  margin-left: 10px;
  cursor: pointer;
}
/deep/ .ant-input-group .ant-input {
  height: 40px !important;
}
.help-text {
  color: #8393a3;
  font-size: 14px;
  margin-top: 12px;
  text-indent: 24px;
}
.help-select {
  margin-left: 144px;
  margin-top: -20px;
  /* margin-bottom: 24px; */
  padding-bottom: 20px;
  color: #8393a3;
  font-size: 14px;
}
.card-text {
  min-width: 85px;
}
.el-button--primary {
  background: #176de6;
}
.demo-ruleForm{
 
}
</style>